import { takeLatest, put } from "redux-saga/effects";
import { ApiCall } from "../api";
import { EQ_OBTENER_COMPLETE, EQ_OBTENER_START } from "../../const/actionTypes";
// import { addMinutes } from "date-fns";

export function* GetEquipos({ payload }) {
  const json = yield ApiCall(
    "/api/Equipo/ObtenerTokens",
    "POST",
    JSON.stringify({}),
    null,
  );
  yield put({ type: EQ_OBTENER_COMPLETE, payload: json });
}

export default function* equipos() {
  yield takeLatest(EQ_OBTENER_START, GetEquipos);
}
